// import React from "react";
import { useDarkMode } from "../darkmode/DarkModeContext";

const Step1 = ({ formData, errors, handleInputChange, handleNext }) => {
  const { isDarkMode } = useDarkMode();

  return (
    <div
      className={`max-w-md mx-auto rounded-2xl p-6 space-y-6 shadow-lg transition-all duration-500 ${
        isDarkMode
          ? "bg-gray-900 text-white border border-gray-700"
          : "bg-white text-gray-900"
      }`}
    >
      {/* Header */}
      <div className="text-center mb-6">
        <h3
          className={`text-2xl font-bold mb-2 ${
            isDarkMode ? "text-white" : "text-gray-900"
          }`}
        >
          Informasi Personal
        </h3>
        <p
          className={`text-sm ${
            isDarkMode ? "text-gray-400" : "text-gray-600"
          }`}
        >
          Masukkan data diri Anda untuk melanjutkan pengecekan coverage
        </p>
      </div>

      {/* Form Fields */}
      <div className="space-y-4">
        {/* Nama Lengkap */}
        <div>
          <label
            className={`block text-sm font-medium mb-2 ${
              isDarkMode ? "text-white" : "text-gray-900"
            }`}
          >
            Nama Lengkap <span className="text-[#1E9B4C]">*</span>
          </label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <svg
                className="w-5 h-5 text-gray-400"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            <input
              type="text"
              name="fullName"
              value={formData.fullName}
              onChange={handleInputChange}
              className={`w-full pl-10 pr-4 py-3 rounded-lg placeholder-gray-400 focus:ring-2 focus:ring-[#1E9B4C] focus:border-[#1E9B4C] transition-all ${
                isDarkMode
                  ? "bg-gray-800 border border-gray-600 text-white"
                  : "bg-gray-100 border border-gray-300 text-gray-900"
              }`}
              placeholder="Masukkan nama lengkap"
            />
          </div>
          {errors.fullName && (
            <p className="mt-1 text-xs text-red-500">Nama Lengkap wajib diisi</p>
          )}
        </div>

        {/* Nomor Telepon */}
        <div>
          <label
            className={`block text-sm font-medium mb-2 ${
              isDarkMode ? "text-white" : "text-gray-900"
            }`}
          >
            Nomor Telepon <span className="text-[#1E9B4C]">*</span>
          </label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <svg
                className="w-5 h-5 text-gray-400"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
              </svg>
            </div>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleInputChange}
              className={`w-full pl-10 pr-4 py-3 rounded-lg placeholder-gray-400 focus:ring-2 focus:ring-[#1E9B4C] focus:border-[#1E9B4C] transition-all ${
                isDarkMode
                  ? "bg-gray-800 border border-gray-600 text-white"
                  : "bg-gray-100 border border-gray-300 text-gray-900"
              }`}
              placeholder="081234567889"
            />
          </div>
          {errors.phone && (
            <p className="mt-1 text-xs text-red-500">Nomor Telepon wajib diisi</p>
          )}
        </div>

        {/* Email */}
        <div>
          <label
            className={`block text-sm font-medium mb-2 ${
              isDarkMode ? "text-white" : "text-gray-900"
            }`}
          >
            Email <span className="text-[#1E9B4C]">*</span>
          </label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <svg
                className="w-5 h-5 text-gray-400"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
              </svg>
            </div>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              className={`w-full pl-10 pr-4 py-3 rounded-lg placeholder-gray-400 focus:ring-2 focus:ring-[#1E9B4C] focus:border-[#1E9B4C] transition-all ${
                isDarkMode
                  ? "bg-gray-800 border border-gray-600 text-white"
                  : "bg-gray-100 border border-gray-300 text-gray-900"
              }`}
              placeholder="nama@email.com"
            />
          </div>
          {errors.email && (
            <p className="mt-1 text-xs text-red-500">Email wajib diisi</p>
          )}
        </div>
      </div>

      {/* Continue Button */}
      <div className="pt-4">
        <button
          onClick={handleNext}
          className="w-full flex items-center justify-center px-6 py-3 bg-[#1E9B4C] hover:bg-green-700 text-white font-semibold rounded-lg transition-all duration-200 shadow-lg hover:shadow-xl"
        >
          Lanjutkan
          <svg
            className="w-5 h-5 ml-2"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M17 8l4 4m0 0l-4 4m4-4H3"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Step1;
